export const Colors = {
    Maintheme : "#373737",
    primaryTextColor : "#373737",
    secondaryTextColor : "#515151",
    tertiaryTextColor : "#979797",
    backgroundColorSecondary : "#D7D7D7",
    logoColor : "#D7D7D7"
} as const